import React from "react";
import { CircularProgress, Sheet, Stack, Typography } from "@mui/joy";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

const styles = {
    container: {
        p: 2,
        borderRadius: 4,
        border: "1px solid",
        borderColor: "neutral.outlinedBorder",
        maxWidth: 350,
    },
    icon: {
        width: "24px",
    },
    progressIndicator: {
        "--CircularProgress-size": "24px",
    },
    errorText: {
        color: "danger.500",
    },
    progressText: {
        color: "neutral.500",
    },
} as const;

export type FileUploadProps = {
    id: string;
    name: string;
    progress: number;
    index: number;
    createdAt: Date;
    size: number;
};

export class FileUpload extends React.Component<{ file: FileUploadProps }> {
    render() {
        return (
            <Sheet variant="soft" color="neutral" sx={styles.container}>
                <Stack direction="row" spacing={1}>
                    {this.props.file.progress === 100 ? (
                        <DescriptionOutlinedIcon sx={styles.icon} />
                    ) : (
                        <CircularProgress
                            determinate={this.props.file.progress !== -1}
                            value={this.props.file.progress}
                            variant="solid"
                            color={this.props.file.progress === -1 ? "danger" : "neutral"}
                            size="sm"
                            sx={styles.progressIndicator}
                        />
                    )}

                    <Stack spacing={0.5}>
                        <Typography level="body-sm" fontWeight="bold" noWrap>
                            {this.props.file.name}
                        </Typography>
                        {this.props.file.progress === -1 ? (
                            <Typography level="body-xs" sx={styles.errorText}>
                                Upload failed - please try again
                            </Typography>
                        ) : (
                            this.props.file.progress < 100 && (
                                <Typography level="body-xs" sx={styles.progressText}>
                                    {Math.round(this.props.file.progress)}% uploaded
                                </Typography>
                            )
                        )}
                    </Stack>
                </Stack>
            </Sheet>
        );
    }
}
